import { Box, useTheme } from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { FormContainer } from '../../containers/FormContainer/FormContainer';
import { Copy } from '../../copy/Copy';
import { buttonSx } from '../../styles/Global.style';
import { Form } from '../Form/Form';
import { FormInput } from '../FormInput/FormInput';
import { Button } from '../Button/Button';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { APP_PATHS } from '../../constants/paths';
import { POST_INIT_VALUES, POST_MAX_CHARS } from '../../constants/post';
import { savePost } from '../../helpers/savePost';
import { POST_VALIDATION_SCHEMA } from '../../validation/post';
import { Text } from '../Text/Text';
import { charCountContainerSx, charCountSx } from './PostForm.style';
import { Loading } from '../Loading/Loading';

export const PostForm = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const [message, setMessage] = useState();
  const [isError, setIsError] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const resetError = () => {
    setTimeout(() => {
      setMessage('');
      setIsError(false);
    }, 3000);
  };

  const formik = useFormik({
    initialValues: POST_INIT_VALUES,
    validationSchema: POST_VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (val) => {
      setIsLoading(true);

      try {
        await savePost({
          data: {
            userId: user.id,
            content: val.content,
            name: `${user.firstName} ${user.lastName}`,
            likes: 0,
          },
          jwt: user?.jwt,
        });

        location.href = APP_PATHS.community;
      } catch (err) {
        setIsError(true);
        setMessage(err.message);
        resetError();
      }
    },
  });

  useEffect(() => {
    setCharCount(formik.values.content.length);
  }, [formik.values.content.length]);

  return !isLoading ? (
    <FormContainer>
      <Form formik={formik} isError={isError} message={message}>
        <FormInput
          inputFor="content"
          formik={formik}
          labelText={Copy.generate('Inputs.post')}
          inputType="textarea"
          multiline
          rows={8}
          inputProps={POST_MAX_CHARS}
        />

        <Box sx={charCountContainerSx}>
          <Text
            text={`${charCount.toString()}/500 characters`}
            sx={charCountSx}
          />
        </Box>

        <Button
          type="submit"
          fullWidth
          text={Copy.generate('Buttons.post')}
          sx={buttonSx(theme)}
        />
      </Form>
    </FormContainer>
  ) : (
    <Loading />
  );
};
